var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "blog__head" }, [
    _c("div", { staticClass: "blog__container container" }, [
      _c("div", { staticClass: "blog__filter" }, [
        _vm._v("\n            Filter\n            "),
        _c(
          "svg",
          {
            attrs: {
              width: "512px",
              height: "512px",
              viewBox: "0 0 512 512",
              xmlns: "http://www.w3.org/2000/svg",
            },
          },
          [
            _c("path", {
              staticClass: "ci-primary",
              attrs: {
                d: "M238.627,496H192V253.828l-168-200V16H480V53.612l-160,200V414.627ZM224,464h1.373L288,401.373V242.388L443.51,48H60.9L224,242.172Z",
              },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "filters" }, [
        _c("div", { staticClass: "filters__head" }, [
          _c("div", { staticClass: "filters__title" }, [_vm._v("Filter")]),
          _vm._v(" "),
          _c("button", { staticClass: "filters__close" }, [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "17.678",
                  height: "17.678",
                  fill: "#009dbb",
                  viewBox: "0 0 18 18",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M16.97 2.122L2.121 16.971a1 1 0 1 1-1.414-1.414L15.556.708a1 1 0 1 1 1.414 1.414z",
                  },
                }),
                _c("path", {
                  attrs: {
                    d: "M15.556 16.97L.707 2.121A1 1 0 1 1 2.121.707L16.97 15.556a1 1 0 1 1-1.414 1.414z",
                  },
                }),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "filters__body" }, [
          _c("div", { staticClass: "filters__row" }, [
            _c("div", { staticClass: "filters__col" }, [
              _c(
                "ul",
                { staticClass: "filters__links" },
                [
                  _c("li", [
                    _c(
                      "a",
                      {
                        class: { active: _vm.catId == 0 },
                        on: {
                          click: function ($event) {
                            return _vm.setCategory(0)
                          },
                        },
                      },
                      [_vm._v("Latest")]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.categories, function (cat) {
                    return _c("li", [
                      _c(
                        "a",
                        {
                          class: { active: _vm.catId == cat.Id },
                          on: {
                            click: function ($event) {
                              return _vm.setCategory(cat.Id)
                            },
                          },
                        },
                        [_vm._v(_vm._s(cat.Name))]
                      ),
                    ])
                  }),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "filters__col" }, [
              _c("div", { staticClass: "filters__search" }, [
                _c(
                  "button",
                  {
                    staticClass: "filters__button",
                    on: { click: _vm.emitChange },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "26",
                          height: "26",
                          viewBox: "0 0 26 26",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M18.582 16.352h-1.174l-.416-.4A9.68 9.68 0 0 0 2.806 2.807a9.68 9.68 0 0 0 13.145 14.186l.4.416v1.174L23.785 26 26 23.785zm-8.919 0a6.69 6.69 0 1 1 0-13.38 6.69 6.69 0 0 1 6.69 6.69 6.68 6.68 0 0 1-6.69 6.69z",
                            fill: "#f24b4d",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.query,
                      expression: "query",
                    },
                  ],
                  staticClass: "filters__input",
                  attrs: { type: "text", name: "query", placeholder: "Search" },
                  domProps: { value: _vm.query },
                  on: {
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.emitChange.apply(null, arguments)
                    },
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.query = $event.target.value
                    },
                  },
                }),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }